import * as React from 'react'
import { ReactElement } from 'react'
import { SurchargeType } from '../../../config/i18nConfig'
import I18NCombobox, { I18NComboboxProps } from './I18NCombobox'
import useSurchargeTypes from '../../../hooks/useSurchargeTypes'

export type SurchargeTypeComboboxProps = Omit<I18NComboboxProps<SurchargeType>, 'entities' | 'idKey'>

export default function SurchargeTypeCombobox(props: SurchargeTypeComboboxProps): ReactElement {
    const { surchargeTypes } = useSurchargeTypes()

    return (
        <I18NCombobox<SurchargeType>
            entities={surchargeTypes}
            idKey={'id'}
            placeholderKey={'base.surchargetypecombobox.placeholder'}
            {...props}
        />
    )
}
